import { RxCrop, RxPencil2 } from "react-icons/rx";

import SpaceCity1 from "../../asets/Images/banner-1.jpg";
import SpaceCity9 from "../../asets/Images/banner-2.jpg";

export const ServiceData = [
  {
    icon: RxCrop,
    title: "Embrace Learning, Embrace Success",
    content:
      "Expert Hands-On Training in Software, Digital Marketing & Animation for a Promising Career",
    backgroundImage: SpaceCity9,
  },
  {
    icon: RxPencil2,
    title: "Unlock Your Business Potential",
    content:
      "Tailor-Made Software Solutions for Every Need, Designed to Boost Your Productivity and Drive Success",
    backgroundImage: SpaceCity1,
  },
];
